"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInternalUser = exports.isUserAuthorisedToUseApp = exports.userHasFeature = exports.isEmptyObject = exports.isNumber = exports.isString = exports.isUUID = exports.isStringArray = exports.isUndefinedOrNullOrEmptyArray = exports.isUndefinedOrNullOrEmptyString = exports.isUndefinedOrNull = exports.isDefined = void 0;
var constants_1 = require("./constants");
var types_1 = require("./types");
/**
 * Checks if object passed is null or undefined
 * @param object
 * @returns boolean
 */
var isDefined = function (object) {
    return object !== undefined && object !== null;
};
exports.isDefined = isDefined;
/**
 * Checks if object passed is null or undefined
 * @param object
 * @returns boolean
 */
var isUndefinedOrNull = function (object) {
    return object === undefined || object === null;
};
exports.isUndefinedOrNull = isUndefinedOrNull;
/**
 * Checks if object passed is null OR undefined OR empty string
 * @param object
 * @returns boolean
 */
var isUndefinedOrNullOrEmptyString = function (object) {
    return (0, exports.isUndefinedOrNull)(object) || object === '';
};
exports.isUndefinedOrNullOrEmptyString = isUndefinedOrNullOrEmptyString;
/**
 * Checks whether the array passed is null OR undefined OR empty
 * @param object
 * @returns false for objects, true or false for arrays
 */
var isUndefinedOrNullOrEmptyArray = function (object) {
    return !Array.isArray(object) || !object.length;
};
exports.isUndefinedOrNullOrEmptyArray = isUndefinedOrNullOrEmptyArray;
/**
 * Checks if value is an array of strings
 * @param value
 * @returns boolean
 */
var isStringArray = function (value) {
    return typeof value !== 'string' && !(0, exports.isUndefinedOrNull)(value);
};
exports.isStringArray = isStringArray;
/**
 * Checks if the input stirng is a UUID
 * @param uuid
 * @returns true or false
 */
var isUUID = function (uuid) {
    return uuid.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$') !== null;
};
exports.isUUID = isUUID;
/**
 * Checks if passed parameter is of type string
 * @param item
 * @returns
 */
var isString = function (item) {
    return !!item;
};
exports.isString = isString;
/**
 * Checks if passed parameter is of type number
 * @param item
 * @returns
 */
var isNumber = function (item) {
    return !!item;
};
exports.isNumber = isNumber;
/**
 * Checks if an object is empty
 * @param obj
 * @returns true or false
 */
var isEmptyObject = function (obj) {
    return typeof obj === 'object' && Object.keys(obj).length === 0;
};
exports.isEmptyObject = isEmptyObject;
/**
 * Checks if a user has a specific customer feature
 * @param user
 * @param feature
 * @returns true or false
 */
var userHasFeature = function (user, feature) {
    if ((0, exports.isUndefinedOrNull)(user) || (0, exports.isUndefinedOrNullOrEmptyString)(feature) || (0, exports.isUndefinedOrNullOrEmptyArray)(user.customer_features))
        return false;
    return user.customer_features.indexOf(feature.trim()) !== -1;
};
exports.userHasFeature = userHasFeature;
var isUserAuthorisedToUseApp = function (appName, user) {
    var _a;
    var plan_handle = (_a = user.plan_handle) !== null && _a !== void 0 ? _a : 'free';
    if (appName === types_1.MaintenancePages.Platform || appName.endsWith(types_1.MaintenancePages.MaintenanceSuffix))
        return true;
    var hasDashboardsOnlyFeature = (0, exports.userHasFeature)(user, constants_1.CustomerFeatures.DASHBOARD_ONLY_EXCl_AUD_CHARTS);
    var hasDashboardsNonGWICreatorFeature = (0, exports.userHasFeature)(user, constants_1.CustomerFeatures.DASHBOARDS_NON_GWI_CREATOR_PRODUCT_ONLY);
    var hasDashboardsPlan = user.plan_handle === 'dashboards';
    if (plan_handle === 'view_only') {
        var view_only_supported_mfes = constants_1.PERMISSION_BASED_MFES.get(plan_handle);
        if (view_only_supported_mfes)
            return view_only_supported_mfes[appName];
        else
            return false;
    }
    if (appName === types_1.MicrofrontendName.GLOBAL_SEARCH) {
        if (hasDashboardsPlan && hasDashboardsOnlyFeature && hasDashboardsNonGWICreatorFeature) {
            return true;
        }
        else if (hasDashboardsPlan && hasDashboardsOnlyFeature) {
            return false;
        }
    }
    if ((appName === types_1.MicrofrontendName.CHART_BUILDER || appName === types_1.MicrofrontendName.AUDIENCES) && hasDashboardsOnlyFeature)
        return false;
    if (appName === types_1.MicrofrontendName.TV_RF || appName === types_1.MicrofrontendName.TV_STUDY)
        return (0, exports.userHasFeature)(user, constants_1.CustomerFeatures.TV_RF_USER);
    if (appName === types_1.MicrofrontendName.ACTIVATION)
        return (0, exports.userHasFeature)(user, constants_1.CustomerFeatures.AUDIENCE_ACTIVATION_CONNECTIONS);
    var supportedMfes = constants_1.PERMISSION_BASED_MFES.get(plan_handle);
    if (supportedMfes)
        return supportedMfes[appName];
    else
        return false;
};
exports.isUserAuthorisedToUseApp = isUserAuthorisedToUseApp;
var isInternalUser = function (user) {
    if ((0, exports.isUndefinedOrNull)(user.email))
        return false;
    var hasGWIEmail = user.email.toLowerCase().indexOf('@globalwebindex.com') > 0 ||
        user.email.toLowerCase().indexOf('@globalwebindex.net') > 0 ||
        user.email.toLowerCase().indexOf('@gwi.com') > 0 ||
        user.email.toLowerCase().indexOf('@gwi.net') > 0;
    return hasGWIEmail;
};
exports.isInternalUser = isInternalUser;
